import { render } from "./App.vue?vue&type=template&id=55996f10"
const script = {}

import "./App.vue?vue&type=style&index=0&id=55996f10&lang=css"

import exportComponent from "/home/runner/work/FTYP-Frontend/FTYP-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__